/* Desert Drip purchase controller. Replaces both legacy purchase scripts. */
(function (global, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else {
    global.DDPurchase = api;
    var start = function () { api.init(document, window); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  function createModel(config, initial) {
    initial = initial || {};
    var variants = config.variants || [];
    if (!variants.length) throw new Error('Desert Drip purchase data has no variants.');
    var byId = function (id) { return variants.find(function (v) { return String(v.id) === String(id); }); };
    var selected = byId(initial.variantId) || byId(initial.fallbackVariantId) || variants[0];
    var mode = initial.purchaseType === 'subscribe' ? 'subscribe' : 'onetime';
    var planId = String(initial.planId || initial.fallbackPlanId || '');

    function plans(v) { return v.oneTimeOnly ? [] : (v.plans || []); }
    function plan(v, id) { return plans(v).find(function (p) { return String(p.id) === String(id); }); }
    if (initial.hasPlanParameter) {
      // A malformed or unavailable plan must never silently enroll the customer.
      mode = plan(selected, initial.planId) ? 'subscribe' : 'onetime';
    }
    function reconcile() {
      if (!plans(selected).length) mode = 'onetime';
      if (!plan(selected, planId)) planId = plans(selected).length ? String(plans(selected)[0].id) : '';
    }
    reconcile();

    function money(cents) {
      return new Intl.NumberFormat(config.locale || 'en-US', {
        style: 'currency', currency: config.currency || 'USD'
      }).format(cents / 100);
    }
    function view() {
      var selectedPlan = plan(selected, planId);
      var subscribing = mode === 'subscribe' && !!selectedPlan;
      var current = subscribing ? selectedPlan.price : selected.price;
      var renewal = selectedPlan && Number.isFinite(selectedPlan.renewalPrice) ? selectedPlan.renewalPrice : null;
      var cadence = selectedPlan && selectedPlan.intervalLabel;
      return {
        variantId: String(selected.id), purchaseType: subscribing ? 'subscribe' : 'onetime',
        planId: subscribing ? String(selectedPlan.id) : '', selectedPlanId: planId,
        subscriptionAvailable: plans(selected).length > 0, available: selected.available !== false,
        price: current, priceText: money(current), oneTimeText: money(selected.price),
        subscriptionText: selectedPlan ? money(selectedPlan.price) : '',
        renewalText: selectedPlan && renewal !== null ? money(selectedPlan.price) + ' today, then ' + money(renewal) + (cadence ? ' every ' + cadence : ' per delivery') + '.' : '',
        firstDiscount: selectedPlan && selected.price > 0 ? Math.round((1 - selectedPlan.price / selected.price) * 100) : 0,
        availablePlanIds: plans(selected).map(function (p) { return String(p.id); }),
        cards: variants.map(function (v) {
          var p = mode === 'subscribe' ? plan(v, planId) || plans(v)[0] : null;
          var cents = p ? p.price : v.price;
          return { id: String(v.id), active: v === selected, available: v.available !== false,
            priceText: money(cents), compareText: p && cents < v.price ? money(v.price) : '',
            perServingText: v.servings ? money(Math.round(cents / v.servings)) + '/serving' : '',
            priceLabel: p ? 'First order' : 'One-time' };
        })
      };
    }
    return {
      view: view,
      selectVariant: function (id) { var v = byId(id); if (v) { selected = v; reconcile(); } return view(); },
      selectType: function (value) { mode = value === 'subscribe' ? 'subscribe' : 'onetime'; reconcile(); return view(); },
      selectPlan: function (id) { if (plan(selected, id)) planId = String(id); return view(); }
    };
  }

  function init(doc, win) {
    doc.querySelectorAll('.ddx-sub').forEach(function (root) {
      if (root.dataset.ddPurchaseReady) return;
      var scope = root.closest('product-info') || root.closest('.shopify-section') || doc;
      var dataNode = scope.querySelector('[data-dd-purchase-data]');
      var cards = Array.from(scope.querySelectorAll('.dd-package__card'));
      var form = scope.querySelector('form[action*="/cart/add"]');
      if (!dataNode || !cards.length || !form) return;
      var config;
      try { config = JSON.parse(dataNode.textContent); } catch (error) { console.error('Invalid Desert Drip purchase data.', error); return; }
      var variantInput = form.querySelector('[name="id"]');
      var frequency = root.querySelector('.ddx-freq-select');
      var subscription = root.querySelector('.ddx-opt--sub');
      var onetime = root.querySelector('.ddx-opt--ot');
      if (!variantInput || !subscription || !onetime) return;
      var radio = root.querySelector('input[name="ddx-buy"]:checked');
      var activeCard = cards.find(function (card) { return card.classList.contains('is-active'); });
      var url = new URL(win.location.href);
      var options = frequency ? Array.from(frequency.options) : [];
      // Shopify renders current prices; card metadata supplies the merchandising rule.
      config.variants = config.variants.filter(function (v) { return cards.some(function (c) { return c.dataset.variantId === String(v.id); }); });
      config.variants.forEach(function (v) {
        var card = cards.find(function (c) { return c.dataset.variantId === String(v.id); });
        var title = card.querySelector('strong');
        var match = title && title.textContent.match(/(\d+)\s*(?:pack|serving|stick)/i);
        v.servings = Number(card.dataset.servings) || (match ? Number(match[1]) : null);
        v.oneTimeOnly = card.dataset.onetimeOnly === 'true';
        (v.plans || []).forEach(function (p) {
          var option = options.find(function (o) { return o.value === String(p.id); });
          if (option) p.intervalLabel = option.textContent.trim();
        });
      });
      if (!config.variants.length) return;
      var model = createModel(config, {
        variantId: url.searchParams.get('variant'),
        fallbackVariantId: activeCard ? activeCard.dataset.variantId : variantInput.value,
        purchaseType: radio ? radio.value : 'onetime',
        hasPlanParameter: url.searchParams.has('selling_plan'),
        planId: url.searchParams.get('selling_plan'), fallbackPlanId: frequency ? frequency.value : ''
      });
      var planInput = form.querySelector('[name="selling_plan"]');
      if (!planInput) { planInput = doc.createElement('input'); planInput.type = 'hidden'; planInput.name = 'selling_plan'; form.appendChild(planInput); }
      var renewal = root.querySelector('.ddx-renewal');
      if (!renewal) { renewal = doc.createElement('span'); renewal.className = 'ddx-renewal'; renewal.setAttribute('aria-live', 'polite'); subscription.appendChild(renewal); }
      var subTitle = subscription.querySelector('.ddx-title');
      if (subTitle) subTitle.textContent = 'Subscribe & save';
      root.dataset.ddPurchaseReady = 'true';

      function text(selector, value, parent) {
        (parent || scope).querySelectorAll(selector).forEach(function (node) { node.textContent = value; });
      }
      function inputValue(input, value, disabled) {
        var changed = input.value !== value || input.disabled !== disabled;
        input.value = value; input.disabled = disabled;
        if (changed) input.dispatchEvent(new win.Event('change', { bubbles: true }));
      }
      function render(updateUrl) {
        var view = model.view();
        cards.forEach(function (card) {
          var cardView = view.cards.find(function (v) { return v.id === card.dataset.variantId; });
          if (!cardView) return;
          card.classList.toggle('is-active', cardView.active);
          card.setAttribute('aria-pressed', cardView.active ? 'true' : 'false');
          card.disabled = !cardView.available;
          var price = card.querySelector('b');
          if (price) {
            price.textContent = cardView.priceText;
            if (cardView.compareText) { var was = doc.createElement('s'); was.className = 'ddp-once'; was.textContent = cardView.compareText; price.appendChild(doc.createTextNode(' ')); price.appendChild(was); }
          }
          text('.dd-package__per', cardView.perServingText, card);
          var label = card.querySelector('.dd-package__price-label');
          if (!label) { label = doc.createElement('span'); label.className = 'dd-package__price-label'; card.appendChild(label); }
          label.textContent = cardView.priceLabel;
          card.querySelectorAll('.dd-package__save, small').forEach(function (node) { node.hidden = true; });
        });
        root.querySelectorAll('input[name="ddx-buy"]').forEach(function (r) { r.checked = r.value === view.purchaseType; });
        subscription.hidden = !view.subscriptionAvailable;
        subscription.style.display = view.subscriptionAvailable ? '' : 'none';
        subscription.classList.toggle('is-active', view.purchaseType === 'subscribe');
        onetime.classList.toggle('is-active', view.purchaseType === 'onetime');
        if (frequency) {
          options.forEach(function (option) { option.disabled = view.availablePlanIds.indexOf(option.value) === -1; });
          frequency.value = view.selectedPlanId;
        }
        text('.ddx-now', view.subscriptionText, root);
        text('.ddx-was, .ddx-ot', view.oneTimeText, root);
        text('.ddx-badge', view.firstDiscount ? 'SAVE ' + view.firstDiscount + '% ON YOUR FIRST ORDER' : 'SUBSCRIBE', root);
        renewal.textContent = view.renewalText;
        text('.dd-custom-price__current, .dd-sticky-atc__price', view.priceText);
        scope.querySelectorAll('.dd-custom-price__compare').forEach(function (node) { node.hidden = true; node.style.display = 'none'; });
        inputValue(variantInput, view.variantId, false);
        inputValue(planInput, view.planId, !view.planId);
        // Setting disabled omits selling_plan entirely from a one-time cart request.
        var submit = form.querySelector('[name="add"]');
        // Dawn's in-flight guard is aria-disabled=true while .loading is set.
        // Preserve it during capture-phase submits and selection changes.
        if (submit && !submit.classList.contains('loading')) {
          submit.disabled = !view.available;
          submit.setAttribute('aria-disabled', view.available ? 'false' : 'true');
        }
        if (updateUrl && win.location.pathname.indexOf('/products/') !== -1) {
          var next = new URL(win.location.href);
          next.searchParams.set('variant', view.variantId);
          if (view.planId) next.searchParams.set('selling_plan', view.planId);
          else next.searchParams.delete('selling_plan');
          win.history.replaceState(win.history.state, '', next.toString());
        }
        return view;
      }
      function imageForSelection() {
        var selected = cards.find(function (card) { return card.dataset.variantId === model.view().variantId; });
        var src = selected && selected.dataset.swapImage;
        doc.dispatchEvent(new win.CustomEvent('dd:package-image', { detail: src ? { src: src } : { reset: true } }));
      }
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          model.selectVariant(card.dataset.variantId); render(true); imageForSelection();
        });
      });
      root.addEventListener('change', function (event) {
        if (event.target.matches('input[name="ddx-buy"]')) model.selectType(event.target.value);
        else if (event.target === frequency) model.selectPlan(frequency.value);
        else return;
        render(true);
      });
      // Ensure Dawn's submit listener sees the latest atomic selection.
      form.addEventListener('submit', function () { render(false); }, true);
      render(false); imageForSelection();
      // The gallery initializes after DOMContentLoaded on some templates.
      win.setTimeout(imageForSelection, 400);
    });
  }
  return { createModel: createModel, init: init };
});
